<mat-dialog-content class="Intro-Component">
  <div class="container">
    <div class="widget widget2 card">
      <div class="header">
        <!-- instruction_header -->
        <h3>
          <button style="cursor: auto">مدخل إلى فهم اضطراب التلعثم :</button>
        </h3>
      </div>
      <div class="widget2-body">
        <!-- instruction_details -->
        <div>
          <div>
            <a class="link-info font-size-20">
              إعلم أخي الغالي وأختي الغالية :
            </a>
            <div
              class="wow fadeInUp"
              data-wow-duration="1.5s"
              data-wow-delay="1s"
              style="
                visibility: visible;
                animation-duration: 1.5s;
                animation-name: fadeInUp;
              "
            >
              <ul class="platform-information">
                <li>
                  <!-- <i class="ik ik-chevron-left"></i> -->
                  <img
                    src="assets/images/icons/chevron-left-green.svg"
                    alt="chevron left"
                  />
                  أن التلعثم هو اضطراب يصيب الشخص في طلاقة كلامه .
                </li>
                <li>
                  <!-- <i class="ik ik-chevron-left"></i> -->
                  <img
                    src="assets/images/icons/chevron-left-green.svg"
                    alt="chevron left"
                  />
                  يحدث اضطراب التلعثم في الطفولة المبكرة نتيجة استعداد جسدي لدى
                  الشخص .
                </li>
                <li>
                  <!-- <i class="ik ik-chevron-left"></i> -->
                  <img
                    src="assets/images/icons/chevron-left-green.svg"
                    alt="chevron left"
                  />
                  يتعرض الطفل أثناء فترة نموه عندما يتلعثم للسخرية والضحك
                  والتعليق من أقرانه وربما الكبار مما يجعله يكتسب عادات سيئة في
                  الكلام وتظهر لديه أعراض نفسية تتمثل معظمها في الخوف والقلق .
                </li>
                <li>
                  <!-- <i class="ik ik-chevron-left"></i> -->
                  <img
                    src="assets/images/icons/chevron-left-green.svg"
                    alt="chevron left"
                  />
                  التلعثم هو اضطراب كلامي، ليس كما يعتقد الآخرون أنه اضطراب عقلي
                  أو نفسي وكذلك ليس له علاقة بالذكاء .
                </li>
                <li>
                  <!-- <i class="ik ik-chevron-left"></i> -->
                  <img
                    src="assets/images/icons/chevron-left-green.svg"
                    alt="chevron left"
                  />
                  اعلم أنك لست وحدك من يعاني من اضطراب التلعثم؛ بل يوجد آخرون
                  كثر يعانون منه .
                </li>
                <li>
                  <!-- <i class="ik ik-chevron-left"></i> -->
                  <img
                    src="assets/images/icons/chevron-left-green.svg"
                    alt="chevron left"
                  />
                  اعلم انك تتكلم بطلاقة أفضل عندما تكون وحيدا أو عندما ترتل
                  القرآن أو تنشد أو تغني .
                </li>
                <li>
                  <!-- <i class="ik ik-chevron-left"></i> -->
                  <img
                    src="assets/images/icons/chevron-left-green.svg"
                    alt="chevron left"
                  />
                  نظرا لأن معظم أعراض التلعثم هي عادات مكتسبة فإن برنامجنا
                  المسمى ب SHS (تزامن الكلام مع حركة اليد) تم تطويره من أجل
                  التخلص من العادات السيئة فى الكلام وذلك عبر تعلم واكتساب عادات
                  جيده للكلام تحل محلها .
                </li>
                <li>
                  <!-- <i class="ik ik-chevron-left"></i> -->
                  <img
                    src="assets/images/icons/chevron-left-green.svg"
                    alt="chevron left"
                  />
                  يمكنك التعرف على اضطراب التلعثم لديك وردود أفعالك عن قرب وذلك
                  باستخدام المرأة والكلام أمامها وحدك ومراقبة طريقة كلامك
                  وتعابير وجهك دون خوف .
                </li>
                <li>
                  <!-- <i class="ik ik-chevron-left"></i> -->
                  <img
                    src="assets/images/icons/chevron-left-green.svg"
                    alt="chevron left"
                  />
                  جرب أن تتكلم أمام المرآة بطرق مختلفة مثل: الكلام ببطء والكلام
                  السريع. تقليد صوت شخص كبير وكذلك صوت شخص صغير. أيضا تقليد
                  امرأة/رجل/طفل ...الخ. يمكنك أن تدون ملاحظاتك على طريقة كلامك
                  ومدى طلاقته .
                </li>
              </ul>
            </div>

            <a class="link-info">أرجو أن تجيب على هذين السؤالين :</a>
            <ul class="platform-information">
              <li>
                <!-- <i class="ik ik-chevron-left"></i> -->
                <img
                  src="assets/images/icons/chevron-left-green.svg"
                  alt="chevron left"
                />
                هل تعتقد أنك بحاجة إلى علاج اضطراب التلعثم التي لديك ؟
              </li>
              <li>
                <!-- <i class="ik ik-chevron-left"></i> -->
                <img
                  src="assets/images/icons/chevron-left-green.svg"
                  alt="chevron left"
                />
                هل تعتقد أنك قادر على تحقيق النجاح في العلاج ؟
              </li>
            </ul>

            <ul class="platform-information">
              <li>
                <!-- <i class="ik ik-chevron-left"></i> -->
                <img
                  src="assets/images/icons/chevron-left-green.svg"
                  alt="chevron left"
                />
                إن إيمانك بحاجتك إلى علاج اضطراب التلعثم الذي لديك وأنك قادر على
                تحقيق النجاح في العلاج لهو الدافع القوي والحاسم الذي سوف يسهم في
                تجاوز مشكلتك .
              </li>
              <li>
                <!-- <i class="ik ik-chevron-left"></i> -->
                <img
                  src="assets/images/icons/chevron-left-green.svg"
                  alt="chevron left"
                />
                كثير ممن يعاني من التلعثم لا يعلم انه قادرا على تجاوز الاضطراب،
                والتحدث بطلاقة وعدم تجنب أي حدث مهم في الحياة كالزواج والوظيفة .
              </li>
              <li>
                <!-- <i class="ik ik-chevron-left"></i> -->
                <img
                  src="assets/images/icons/chevron-left-green.svg"
                  alt="chevron left"
                />
                كثير من الأشخاص الذين يعانون من التلعثم يعتقدون بعدم جدوى الدخول
                في أي برنامج علاجي. وهذا ناتج عن خبراتهم السلبية السابقة
                والصعوبات التي واجهوها .
              </li>
              <li>
                <!-- <i class="ik ik-chevron-left"></i> -->
                <img
                  src="assets/images/icons/chevron-left-green.svg"
                  alt="chevron left"
                />
                ربما ذهب بعض الأشخاص الذين يعانون من التلعثم إلى معالجين لا
                يمتلكون الخبرة والمعرفة في مجال التلعثم وقدموا لهم نصائح لا تمت
                بصلة إلى مشكلتهم .
              </li>
              <li>
                <!-- <i class="ik ik-chevron-left"></i> -->
                <img
                  src="assets/images/icons/chevron-left-green.svg"
                  alt="chevron left"
                />
                توجد حالات شبيهة إلى حد كبير بحالتك، وبعد استخدام هذا البرنامج
                العلاجي كانت النتائج إيجابية ومُرضية .
              </li>
              <li>
                <!-- <i class="ik ik-chevron-left"></i> -->
                <img
                  src="assets/images/icons/chevron-left-green.svg"
                  alt="chevron left"
                />
                إعلم أنه يوجد مشاهير من العرب والغرب كانوا يعانون من اضطراب
                التلعثم استطاعوا أن يتغلبوا عليها مثل أمير الشعراء أحمد شوقي .
              </li>
            </ul>

            <a class="link-info"
              >إن برنامج طلاقة الكلام الذي أنت بصدد تطبيقه يقوم على نقاط عديدة
              أهمها :</a
            >
            <ul class="platform-information">
              <li>
                <!-- <i class="ik ik-chevron-left"></i> -->
                <img
                  src="assets/images/icons/chevron-left-green.svg"
                  alt="chevron left"
                />
                التركيز على تعلم عادة جديدة للكلام الطلِق بدلا من التركيز على حل
                الاضطراب .
              </li>
              <li>
                <!-- <i class="ik ik-chevron-left"></i> -->
                <img
                  src="assets/images/icons/chevron-left-green.svg"
                  alt="chevron left"
                />
                اكتساب مهارة الكلام الطلق عبر سلسلة الخطوات الصغيرة تبدأ بالكلام
                ببطء بالتزامن مع حركة اليد؛ وذلك بالإنتقال من التدرب في البداية
                على المقاطع الصوتية إلى الكلمات ومن ثم الجمل وصولا إلى الكلام
                الطبيعي .
              </li>
              <li>
                <!-- <i class="ik ik-chevron-left"></i> -->
                <img
                  src="assets/images/icons/chevron-left-green.svg"
                  alt="chevron left"
                />
                سيتم اكتساب العادات الجيدة للتخلص من العادات السيئة عبر المعرفة
                والتشجيع والمهارة .
              </li>
              <li>
                <!-- <i class="ik ik-chevron-left"></i> -->
                <img
                  src="assets/images/icons/chevron-left-green.svg"
                  alt="chevron left"
                />
                تطوير الجانب المعرفي من خلال عرض مجموعة من الأفلام من أجل التخلص
                من الخوف والقلق .
              </li>
              <li>
                <!-- <i class="ik ik-chevron-left"></i> -->
                <img
                  src="assets/images/icons/chevron-left-green.svg"
                  alt="chevron left"
                />
                من المهم أن تؤمن أثناء التدرب أن حدوث الفشل عدة مرات يعد أمرا
                طبيعيا. المطلوب منك حتى تنجح هو أن تكرر المحاولة تلو المحاولة
                حتى تنجح عليك أن تسعد بالفشل! .. لأننا نتعلم من الخطأ أكثر مما
                نتعلمه من الصواب. عليك أن تتدرب بحماس ومثابرة مع أهمية التركيز
                على النجاح في المهمة التي تتدرب عليها ومن ثم تحتفل مع نفسك بهذا
                الإنجاز دون التفكير في المراحل التالية .
              </li>
              <li>
                <!-- <i class="ik ik-chevron-left"></i> -->
                <img
                  src="assets/images/icons/chevron-left-green.svg"
                  alt="chevron left"
                />
                الالتزام والمسؤولية والجد والمثابرة تعد عوامل مهمة لنجاح أي
                برنامج علاجي حيث تسهم بشكل فعال في حل مشكلتك بصورة مرضية .
              </li>
            </ul>
          </div>

          <!-- <br><br><br> -->
          <!-- <div class="video">
            <div class="video-container">
              <iframe width="590" height="332" src="https://www.youtube.com/embed/9tobL8U7dQo" frameborder="0" allowfullscreen="allowfullscreen"></iframe>
            </div>
          </div> -->
          <button (click)="close()" class="btn btn-primary">تخطى</button>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
